export function parseRemarkAndCorrectiveActions(note?: string) {
  if (!note) {
    return { reason: [], remark: "" };
  }

  const { reason, remark } = JSON.parse(note);

  const parsedReason = JSON.parse(reason);

  return { reason: parsedReason as string[], remark: remark as string };
}
